import React from "react";
import img1 from "./imgs/01.jpg";
import img2 from "./imgs/12.RPEX9.jpg";
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../../../locales/config";
import img1en from "./imgs/01en.jpg";
import img2en from "./imgs/12-RPEX9.jpg";

export function RPEX9() {

    const lang = LOCALES_HELPER.getLan();

    return (
        <>
            {lang === DEFAULT_LOCALE
                ? <>
                    <img className="product-img" src={img1}/>
                    <img className="product-img" src={img2}/>
                </>
                : <>
                    <img className="product-img" src={img1en}/>
                    <img className="product-img" src={img2en}/>
                </>
            }
        </>
    )
}
